<template>
  <div>
    <section class="login-container boxed-login">
      <div class="container">
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="j-forms" id="forms-login" novalidate="novalidate">
              <div class="login-form-header">
                <div class="logo">
                  <img class="logo-pic" src="../assets/img/logo3.png" alt="logo">
                </div>
              </div>
              <div class="login-form-content">
                <!-- start login -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="login">
                      <i class="zmdi zmdi-account"></i>
                    </label>
                    <input class="form-control login-frm-input" type="text" id="login" name="email" placeholder="Email" v-model="email" v-validate="'required|email'">
                    <i v-show="errors.has('email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                  </div>
                </div>
                <!-- end login -->
                <!-- start password -->
                <div class="unit">
                  <div class="input login-input">
                    <label class="icon-left" for="password">
                      <i class="zmdi zmdi-key"></i>
                    </label>
                    <input class="form-control login-frm-input" type="password" id="password" name="password" placeholder="密碼" v-model="password">
                  </div>
                </div>
                <!-- end password -->
                <!-- start response from server -->
                <div class="response"></div>
                <!-- end response from server -->
              </div>
              <div class="login-form-footer">
                <button class="btn-block btn btn-primary" v-on:click="signin">登入</button>
              </div>
            </div>
            <div class="login-form-footer">
              <router-link class="btn-block btn btn-primary" to="signup">
                註冊
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Start Here -->
      <footer class="login-page-footer">
      </footer>
      <!--Footer End Here -->
    </section>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'

export default {
  name: 'index',
  components: { Simplert },
  data() {
    return {
      email: '',
      password: '',
      refs: this.$refs
    }
  },
  methods: {
    signin() {
      if (this.email != '' && this.password != '') {
        this.validateBeforeSubmit()
      } else {
        var obj = {
          isShown: true,
          title: '登入失敗',
          message: '請輸入帳號密碼',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        this.refs.simplert.openSimplert(obj);
      }
    },
    toSignin() {
      const vm = this;
      this.axios.post('sessions', {
          user: {
            email: this.email,
            password: this.password,
          }
        })
        .then(function(response) {
          if (response['data']['status'] == 'success') {
            setCookie("auth_token", response['data']['auth_token'])
            setCookie("aside_bar", true)
            vm.axios.defaults.headers.common['Auth-Token'] = response['data']['auth_token']
            vm.$router.push('/dashboard')
          } else if (response['data']['status'] == 'fail') {
            var obj = {
              isShown: true,
              title: '登入失敗',
              message: '請輸入正確帳號密碼',
              type: 'error',
              customCloseBtnText: '關閉'
            }
            vm.refs.simplert.openSimplert(obj);
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        console.log(result)
        if (result) {
          this.toSignin();
        } else {
          var obj = {
            isShown: true,
            title: 'Email格式錯誤',
            message: '請輸入正確Email格式',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          this.refs.simplert.openSimplert(obj);
        }
      });
    },
    // if user have already login, then deny him go login page
    checkLogin() {
      if (getCookie('auth_token')) {
        this.$router.push('/dashboard');
      }
    }
  }
}

function setCookie(cookie_nmae, cookie_value, expire_days) {
  var date = new Date();
  date.setTime(date.getTime() + (expire_days * 24 * 60 * 60 * 1000));
  var expires = "expires=" + date.toUTCString();
  document.cookie = cookie_nmae + "=" + cookie_value + ";" + expires + ";path=/";
}

function getCookie(cookie_key) {
  var key = cookie_key + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var split_val = decodedCookie.split(';');
  for (var i = 0; i < split_val.length; i++) {
    var temp = split_val[i];
    while (temp.charAt(0) == ' ') {
      temp = temp.substring(1);
    }
    if (temp.indexOf(key) == 0) {
      return temp.substring(key.length, temp.length);
    }
  }
  return "";
}
</script>


// WEBPACK FOOTER //
// Index.vue?3d8d3fa5